module.exports = __webpack_public_path__ + "965d3c68652558e7cae9cf33a431823d.png";